"use client";
import React, { useState } from "react";

type TimeFrame = "Hourly" | "Daily" | "Weekly" | "Monthly";

const AnalyticsHeader: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TimeFrame>("Hourly");

  const tabs: TimeFrame[] = ["Hourly", "Daily", "Weekly", "Monthly"];

  return (
    <section className="w-full font-semibold">
      <div className="px-4 w-full">
        <div className="w-full">
          <div className="flex flex-col justify-center w-full">
            <h1 className="w-full text-2xl leading-none text-gray-900">
              Usage Analytics
            </h1>
            <div className="flex gap-1 justify-center items-center p-1 mt-4 w-full text-sm leading-none text-gray-500 whitespace-nowrap bg-gray-50 rounded-xl border border-gray-200 border-solid">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`overflow-hidden flex-1 shrink gap-2 self-stretch px-3 py-2 my-auto rounded-md basis-0 min-h-9 ${
                    activeTab === tab ? "bg-white text-slate-700 shadow" : ""
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalyticsHeader;
